import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { Component } from '@angular/core';

import { environment } from '../environments/environment';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { EnvironmentService } from './services/environment.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      animated: false,
      mode: 'md',
      scrollAssist: true,
    }),
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      // Persistierte Umgebung (Live/Staging/Dev) laden, bevor die App startet
      // und der erste HTTP-Request rausgeht.
      provide: APP_INITIALIZER,
      useFactory: (env: EnvironmentService) => () => env.load(),
      deps: [EnvironmentService],
      multi: true,
    },
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: {
        dateFormat: 'dd.MM.y HH:mm',
      },
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
